import { bytesSizeFormat } from "./bytesSizeFormat"

/**
 *
 * @param {*} file
 * @returns
 */
export function fileInfoStr(file) {
  return `${file.name}, ${bytesSizeFormat(file.size)}`
}
